import { Tab as MUITab, Tabs as MUITabs } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { TabProps } from '@features/ui/components/Tabs';
import { StyledTabTitle, SubTitle } from '@features/ui/components/Tabs/styles';

const Tabs = ({ tabs, currentIndex, className }: TabProps) => {
  const tabsClasses = useTabsStyles();
  const tabClasses = useTabStyles();

  const handleChange = (event: any, newValue: number) => {
    const clickedTab = tabs[newValue];

    if (clickedTab.onClick && !clickedTab.disabled) {
      clickedTab.onClick();
    }
  };
  return (
    <Container className={className}>
      <MUITabs
        classes={tabsClasses}
        value={currentIndex ?? 0}
        onChange={handleChange}
      >
        {tabs.map((tab) => (
          <MUITab
            classes={tabClasses}
            disabled={tab.disabled}
            label={(
              <StyledTabTitle disabled={tab.disabled}>
                {tab.disabled ? (
                  <>
                    {tab.title}
                    {tab.subTitle && <SubTitle>{tab.subTitle}</SubTitle>}

                  </>
                ) : (
                  <>
                    <Link href={tab.href ?? '#'} scroll={false}>
                      <a>
                        {tab.title}
                        {tab.subTitle && <SubTitle>{tab.subTitle}</SubTitle>}
                      </a>
                    </Link>
                  </>
                )}
              </StyledTabTitle>
            )}
            key={tab.key}
            tabIndex={-1}
            data-qa={`ui-tab-item-${tab.qaId}`}
          />
        ))}
      </MUITabs>
    </Container>
  );
};

export default Tabs;

const useTabsStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    width: '100%',
    height: '100%',
  },
  indicator: {
    backgroundColor: 'var(--color-blue)',
    height: '4px',
  },
}));

const useTabStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    height: '84px',
    opacity: 1,
    minWidth: 90,
    textTransform: 'none',
    display: 'flex',
    justifyContent: 'start',
    flexDirection: 'column',
  },
  selected: { color: 'var(--main-text-color)' },
}));

const Container = styled.div`
  width: 100%;

  .MuiTabs-flexContainer {
    justify-content: center;
  }

  .MuiTab-wrapper {
    height: 100%;
  }
  .MuiButtonBase-root:hover {
    ::after {
      position: absolute;
      content: "";
      height: 4px;
      width: calc(100% + 24px);
      bottom: 0px;
      background: var(--color-blue-hover);
    }
  }
`;
